const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:5001';

const getToken = () => localStorage.getItem('jwtToken') || '';

const headers = () => ({
    'Authorization': `Bearer ${getToken()}`,
    'Content-Type': 'application/json'
});

// ─── 1. Get Entitlements for a Company ─────────────────────
export const getEntitlements = async (companyId) => {
    const response = await fetch(
        `${BASE_URL}/entitlements/company/${companyId}`,  // ← CHANGE THIS
        { headers: headers() }
    );
    return response.json();
};

// ─── 2. Get All Entitlement Definitions ────────────────────
export const getEntitlementDefinitions = async () => {
    const response = await fetch(
        `${BASE_URL}/entitlements/definitions`,
        { headers: headers() }
    );
    return response.json();
};

// ─── 3. Get Entitlement List (Alias) ──────────────────────
export const getEntitlementList = async () => {
    const response = await fetch(
        `${BASE_URL}/entitlements/definitions`,
        { headers: headers() }
    );
    return response.json();
};

// ─── 4. Add Individual Entitlement ─────────────────────────
export const addEntitlement = async (companyId, entitlementName, value) => {
    const response = await fetch(
        `${BASE_URL}/entitlements/add`,
        {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({ companyId, entitlementName, value })
        }
    );
    return response.json();
};

// ─── 5. Remove Individual Entitlement ──────────────────────
export const removeEntitlement = async (companyId, entitlementName) => {
    const response = await fetch(
        `${BASE_URL}/entitlements/remove`,
        {
            method: 'POST',
            headers: headers(),
            body: JSON.stringify({ companyId, entitlementName })
        }
    );
    return response.json();
};

// ─── 6. Update Entire Subscription ─────────────────────────
export const updateSubscription = async (companyId, subscription) => {
    const response = await fetch(
        `${BASE_URL}/entitlements/subscription`,
        {
            method: 'PUT',
            headers: headers(),
            body: JSON.stringify({ companyId, subscription })
        }
    );
    return response.json();
};

// ─── 7. Get Company Info ────────────────────────────────────
export const getCompanyInfo = async (companyId) => {
    const response = await fetch(
        `${BASE_URL}/company/${companyId}`,
        { headers: headers() }
    );
    return response.json();
};



// ─── 8. Get Entitlement History ───────────────────────────
export const getEntitlementHistory = async (
    companyId,
    page = 1
) => {
    const response = await fetch(
        `${BASE_URL}/entitlements/history/${companyId}?page=${page}`,
        {
            headers: headers()
        }
    );

    return response.json();
};